import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";

const DTOAboutMeModal = () => {
  return <></>;
};
export default DTOAboutMeModal;
